import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { UtilsService } from "src/app/services/utils";
import { ReceiptRow } from "src/app/types/receiptrow";

@Component({
  selector: "app-list-product",
  templateUrl: "./list-product.component.html",
  styleUrls: ["./list-product.component.scss"],
})
export class ListProductComponent implements OnInit {
  @Input() product: ReceiptRow;
  @Input() productName: string;
  @Input() soldProductCount: number;

  @Output() productClick = new EventEmitter();

  constructor(private utils: UtilsService) { }

  ngOnInit() {}

  doChooseProduct() {
    this.productClick.emit(this.product);
  }

}
